// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fR8qpPA788NBjJ6tlcgA {
    padding-top: 16px;
    padding-bottom: 16px
}
.lw4AZMlFExAjuS8h5KnZ {
    margin-bottom: 14px
}
.oSU5gWjeEF4QozSk4hXA {
    display: flex;
    height: 480px;
    flex-direction: column;
    overflow: hidden;
    border-radius: 5px;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1rem
}
.RCEKBmj3zvDtnPoQpIm7 {
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    font-family: Noto Sans;
    font-size: 17px !important;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.vAakhkGGp93tkBAQQ9qW {
    display: flex;
    align-items: center;
    justify-content: center
}
.IyaJeRRpiNwNB0ipG4Cz {
    margin-top: 2.25rem;
    height: 508px;
    width: 375px;
    overflow: hidden;
    border-radius: 5px
}
.BTOgjT61EH0GugYHdhMO {
    height: 100%;
    width: 100%
}
.HNEXdQUEAuD1lLi4AmMi {
    height: 469px;
    width: 375px;
    -o-object-fit: contain;
       object-fit: contain
}
.K7Me3m_DVlEla45XZaON {
    display: flex;
    align-items: center;
    justify-content: space-between
}
.GJaB2mELVGNNfhZSXS1a {
    display: flex;
    cursor: pointer;
    align-items: flex-end;
    justify-content: flex-end;
    font-size: 14px;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(0 130 202 / var(--tw-text-opacity, 1));
    text-decoration-line: underline
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashbaord.module.css"],"names":[],"mappings":"AACE;IAAA,iBAAgB;IAAhB;AAAgB;AAGhB;IAAA;AAAgB;AAGhB;IAAA,aAAyE;IAAzE,aAAyE;IAAzE,sBAAyE;IAAzE,gBAAyE;IAAzE,kBAAyE;IAAzE,kBAAyE;IAAzE,4DAAyE;IAAzE;AAAyE;AAGzE;IAAA,mBAAiG;IAAjG,oBAAiG;IAAjG,mBAAiG;IAAjG,aAAiG;IAAjG,sBAAiG;IAAjG,0BAAiG;IAAjG,gBAAiG;IAAjG,oBAAiG;IAAjG;AAAiG;AAGjG;IAAA,aAAuC;IAAvC,mBAAuC;IAAvC;AAAuC;AAGvC;IAAA,mBAA6D;IAA7D,aAA6D;IAA7D,YAA6D;IAA7D,gBAA6D;IAA7D;AAA6D;AAG7D;IAAA,YAAoB;IAApB;AAAoB;AAGpB;IAAA,aAAyC;IAAzC,YAAyC;IAAzC,sBAAyC;OAAzC;AAAyC;AAGzC;IAAA,aAAwC;IAAxC,mBAAwC;IAAxC;AAAwC;AAGxC;IAAA,aAAsG;IAAtG,eAAsG;IAAtG,qBAAsG;IAAtG,yBAAsG;IAAtG,eAAsG;IAAtG,gBAAsG;IAAtG,oBAAsG;IAAtG,iDAAsG;IAAtG;AAAsG","sourcesContent":[".container {\n  @apply py-[16px];\n}\n.customBreadCrumbs {\n  @apply mb-[14px];\n}\n.customCol {\n  @apply bg-white h-[480px] p-4 rounded-[5px] overflow-hidden flex flex-col;\n}\n.title {\n  @apply font-bold text-gray-500 font-inter inline-flex items-center gap-1.5 !text-[17px] mb-[10px];\n}\n.customCarousel {\n  @apply flex justify-center items-center;\n}\n.fullCarousel {\n  @apply w-[375px] h-[508px] rounded-[5px] overflow-hidden mt-9;\n}\n.carouselWidth {\n  @apply w-full h-full;\n}\n.banner {\n  @apply w-[375px] h-[469px] object-contain;\n}\n.pawnTicketContainer {\n  @apply flex justify-between items-center;\n}\n.seeAll {\n  @apply text-dashboardMain underline text-secondary flex justify-end items-end font-bold cursor-pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fR8qpPA788NBjJ6tlcgA`,
	"customBreadCrumbs": `lw4AZMlFExAjuS8h5KnZ`,
	"customCol": `oSU5gWjeEF4QozSk4hXA`,
	"title": `RCEKBmj3zvDtnPoQpIm7`,
	"customCarousel": `vAakhkGGp93tkBAQQ9qW`,
	"fullCarousel": `IyaJeRRpiNwNB0ipG4Cz`,
	"carouselWidth": `BTOgjT61EH0GugYHdhMO`,
	"banner": `HNEXdQUEAuD1lLi4AmMi`,
	"pawnTicketContainer": `K7Me3m_DVlEla45XZaON`,
	"seeAll": `GJaB2mELVGNNfhZSXS1a`
};
export default ___CSS_LOADER_EXPORT___;
